exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-title {\n    margin: 10px 10px 10px 10px;\n    /* display: block; */\n  }\n  \n  .mat-dialog-content {\n    border-top: 1px solid #e0d7d7;\n    border-bottom: 1px solid #e0d7d7;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/override-stock/override-stock.component.css
// module id = ../../../../../src/app/mnt-invoices/override-stock/override-stock.component.css
// module chunks = common